export default "__VITE_ASSET__Be6R$yD6__"